import script from "./Policies.vue?vue&type=script&setup=true&lang=js"
export * from "./Policies.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e1d7d4"]])

export default __exports__